import {
    BasicController,
    BasicModel,
    CommandController
} from "@goodgamestudios/core";

import { Localize } from "@goodgamestudios/localization";

import { int } from "@goodgamestudios/math-utilities";

import { NetworkInstance } from "@goodgamestudios/world-assignment";

import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Dialog } from "./Poker2Dialog";
import { Poker2WorldSelectionDialogProperties } from "./Poker2WorldSelectionDialogProperties";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2WorldSelectionDialog extends Poker2Dialog {
    public static NAME: string = "Poker2WorldSelectionDialog";
    private selectionBox: Poker2DynamicCombobox;

    constructor(disp: Container) {
        super(disp);
    }

    protected init(): void {
        this.worldSelection.okButton.label = Poker2Model.languageData.getTextById("generic_connect");
        this.worldSelection.txt_title.text = Poker2Model.languageData.getTextById("generic_select_world");
        this.selectionBox = new Poker2DynamicCombobox(this.worldSelection.worldcombobox);
        super.init();
    }

    protected applyProperties(): void {
        let networkInstances: NetworkInstance[] = BasicModel.instanceProxy.instanceMap;
        this.selectionBox.clearItems();

        for (let i: number = 0; i < networkInstances.length; i++) {
            let networkInstance: NetworkInstance = networkInstances[i];
            let listItem: any = { label: Localize.text("generic_world_international",[networkInstance.instanceId]), data: networkInstance };
            this.selectionBox.addItem(listItem);
        }

        this.selectionBox.updateItemBGs(networkInstances.length);

        let cookieInstance: number = int(Poker2Model.localData.readInstanceId());

        if (cookieInstance != 0)
            this.preSelectInstance(cookieInstance);
        else
            this.preSelectInstance(this.env.defaultInstanceId);
    }

    private preSelectInstance(selectedInstance: number): void {
        for (let i: number = 0; i < this.selectionBox.itemData.length; i++) {
            if ((this.selectionBox.itemData[i].data as NetworkInstance).instanceId === selectedInstance) {
                this.selectionBox.selectItemIndex(i);
                return;
            }
        }
        this.selectionBox.selectItemIndex(1);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.worldSelection.okButton:
                this.selectWorld();
                this.hide();
                break;
        }
    }

    private selectWorld(): void {
        var networkInstance: NetworkInstance = this.selectionBox.selectedData as NetworkInstance;

        CommandController.instance.executeCommand(BasicController.COMMAND_CONNECT_TO_INSTANCEVO, networkInstance);
    }

    public show(): void {
        super.show();
    }

    private get worldSelectionDialogProperties(): Poker2WorldSelectionDialogProperties {
        return this.properties as Poker2WorldSelectionDialogProperties;
    }

    private get worldSelection(): Library.PokerInterface.PokerWorldSelection {
        return this.disp as Library.PokerInterface.PokerWorldSelection;
    }
}

import {Poker2DynamicCombobox} from "../components/Poker2DynamicCombobox";
